import { render, staticRenderFns } from "./ListArticle.vue?vue&type=template&id=44a95e9b&scoped=true"
import script from "./ListArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListArticle.vue?vue&type=style&index=0&id=44a95e9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a95e9b",
  null
  
)

export default component.exports